<canvas #canvas class="chart-canvas"></canvas>
<app-simple-mat-tooltip #tooltip [autoHideTimeout]="tooltipAutoHideTimeout"></app-simple-mat-tooltip>
